import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-only-desktop',
  templateUrl: './only-desktop.component.html',
  styleUrls: ['./only-desktop.component.css']
})
export class OnlyDesktopComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    window.scrollTo(0, 0);
  }

}
